// extracted by mini-css-extract-plugin
export default {"errorBadge":"ErrorBadge_errorBadge__b+8px"};